module.exports = __webpack_public_path__ + "img/status.ddc89d01.svg";